import { User as FirebaseUser } from "firebase/auth";
import { AuthUser } from "../../../domain/models/AuthUser";

export class AuthUserConverter {
  static domainModel(fromExternalModel: FirebaseUser | null): AuthUser | null {
    if (fromExternalModel === null) {
      return null;
    }

    return new AuthUser(
      fromExternalModel.uid,
      fromExternalModel.email,
      fromExternalModel.emailVerified,
      fromExternalModel.metadata.creationTime
        ? new Date(fromExternalModel.metadata.creationTime)
        : null,
      fromExternalModel.metadata.lastSignInTime
        ? new Date(fromExternalModel.metadata.lastSignInTime)
        : null,
    );
  }
}
